import { render, staticRenderFns } from "./CPSkeletonLoader.vue?vue&type=template&id=84a2cd38&scoped=true&"
import script from "./CPSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./CPSkeletonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CPSkeletonLoader.vue?vue&type=style&index=0&id=84a2cd38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a2cd38",
  null
  
)

export default component.exports